"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfoLine = void 0;
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var react_intl_1 = require("react-intl");
var styled_components_1 = __importDefault(require("styled-components"));
var useStyles = core_1.makeStyles(function (theme) {
    return core_1.createStyles({
        typography: {
            wordWrap: 'break-word',
        },
    });
});
var ValueGrid = core_1.withTheme(styled_components_1.default(core_1.Grid)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    align-self: flex-end;\n"], ["\n    align-self: flex-end;\n"]))));
exports.InfoLine = function (props) {
    var title = props.title, _a = props.value, value = _a === void 0 ? '-' : _a, isDate = props.isDate;
    var classes = useStyles();
    return (react_1.default.createElement(core_1.Grid, { container: true, item: true, wrap: "nowrap", alignItems: "flex-start" },
        react_1.default.createElement(core_1.Grid, { item: true, xs: 4 },
            react_1.default.createElement(core_1.Typography, { color: "primary" },
                title,
                " ",
                ': ')),
        react_1.default.createElement(ValueGrid, { item: true, xs: 8 },
            react_1.default.createElement(core_1.Typography, { className: classes.typography }, isDate ? (react_1.default.createElement(react_intl_1.FormattedDate, { value: value, day: "numeric", month: "numeric", year: "numeric", hour: "numeric", minute: "numeric", timeZoneName: "long" })) : (value)))));
};
var templateObject_1;
